// Sections and helpers for the notifications dropdown panel + archive page.
// Extracted from KingdomConnect.jsx so multiple components can import them
// without pulling the whole app shell.

export const NOTIF_SECTIONS = [
  { id: "announcements", label: "Announcements", customIcon: "megaphone",
    types: ["department_announcement", "announcement_reminder"] },
  { id: "listings",      label: "Listings",      customIcon: "gift",
    types: ["donation_listing", "donation_intake"] },
  { id: "assignments",   label: "Assignments",   customIcon: "person",
    types: ["assignment_added", "assignment_removed", "assignment_changed", "assignment_prewarn", "assignment_expired"] },
  { id: "calendar",      label: "Calendar",      customIcon: "calendar",
    types: ["service", "event", "blockout", "appointment", "attendance"] },
  { id: "followups",     label: "Follow-Ups",    customIcon: "chat",
    types: ["followup", "followup_close_request", "followup_close_approved", "followup_close_rejected"] },
  { id: "birthdays",     label: "Birthdays",     customIcon: "birthday-cake",
    types: ["birthday"] },
  { id: "overrides",     label: "Overrides",     customIcon: "warning",
    types: ["override_request", "override_approved", "override_denied", "priority_revert"] },
];

export const NOTIF_OTHER_SECTION = { id: "other", label: "Other", customIcon: "bell", types: [] };

export function notifSectionFor(type) {
  for (const s of NOTIF_SECTIONS) if (s.types.includes(type)) return s.id;
  return NOTIF_OTHER_SECTION.id;
}
